import { render } from "./PaymentMethods.vue?vue&type=template&id=231a73f4&scoped=true&ts=true"
import script from "./PaymentMethods.vue?vue&type=script&lang=ts"
export * from "./PaymentMethods.vue?vue&type=script&lang=ts"

import "./PaymentMethods.vue?vue&type=style&index=0&id=231a73f4&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-231a73f4"]])

export default __exports__